"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CacheStoreType_1 = __importDefault(require("../../enums/CacheStoreType"));
var OversattaTransformer_1 = __importDefault(require("../../services/localization/OversattaTransformer"));
var utilities_1 = require("@ikea-aoa/utilities");
/**
 * This class is used for migrating from Kompis 1.0 to Kompis 2.0.
 */
var LocalizationServiceKompis1Migration = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     */
    function LocalizationServiceKompis1Migration(options) {
        this.localizationPrefixApplication = null;
        this.localizationEndpoints = null;
        this.localizationOverrides = null;
        this.locale = null;
        this.cache = null;
        this.localizationPrefixApplication = options.localizationPrefixApplication;
        this.localizationEndpoints = options.localizationEndpoints;
        this.localizationOverrides = options.localizationOverrides;
        this.locale = options.locale;
        this.cache = options.cache || new utilities_1.GlobalCacheStore();
    }
    /**
     * Sets Kompis 1.0 Översätta data to cache.
     *
     * @param localizedInformation Localized information in Kompis 1.0 format.
     */
    LocalizationServiceKompis1Migration.prototype.setLocalizedInformationToCache = function (localizedInformation) {
        var endpointsCacheKey = JSON.stringify(this.localizationEndpoints);
        var overridesCacheKey = this.localizationOverrides
            ? JSON.stringify(this.localizationOverrides)
            : '';
        var localizedCacheKey = this.locale + endpointsCacheKey + overridesCacheKey;
        var cacheStore = this.cache.getStore(CacheStoreType_1.default.localization);
        var transformer = new OversattaTransformer_1.default({
            localizationPrefixApplication: this.localizationPrefixApplication,
            locale: this.locale
        });
        cacheStore.set(localizedCacheKey, transformer.transform(localizedInformation));
    };
    return LocalizationServiceKompis1Migration;
}());
exports.default = LocalizationServiceKompis1Migration;
//# sourceMappingURL=LocalizationServiceKompis1Migration.js.map